module.exports = __webpack_public_path__ + "static/media/darwinPortraits2.6fd30786.gif";